import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class EdDisconnectedModal extends Vue {

  @Prop() readonly params: any;

  get messageText() : string {
    return 'errors.tryingReconnect';
  }
}